import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { LoggedUser } from "../models/Person";
import i18n, { LanguageType } from "../i18n.config";

interface UserState {
  user: LoggedUser | null;
  language: LanguageType;
}

const getInitialUser = (): LoggedUser | null => {
  try {
    const user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  } catch {
    return null;
  }
};

const getInitialLanguage = (): LanguageType => {
  const userLang = getInitialUser()?.language;
  return (userLang === 'en' || userLang === 'es') ? userLang : (i18n.language as LanguageType);
};

const initialState: UserState = {
  user: getInitialUser(),
  language: getInitialLanguage(),
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<LoggedUser>) => {
      state.user = action.payload;
      localStorage.setItem("user", JSON.stringify(action.payload));
      state.language = (action.payload.language === 'en' || action.payload.language === 'es')
        ? action.payload.language
        : (state.language || 'en');
    },
    setUserLanguage: (state, action: PayloadAction<LanguageType>) => {
      state.language = action.payload;
      if (state.user) {
        state.user.language = action.payload;
        localStorage.setItem("user", JSON.stringify(state.user)); 
      }
    },
    clearUser: (state) => {
      state.user = null;
      state.language = i18n.language as LanguageType;
      localStorage.clear();
    },
    setNewAvatar: (state, action: PayloadAction<string>) => {
      if (state.user) {
        state.user.avatar_url = action.payload;
        localStorage.setItem("user", JSON.stringify(state.user));
      }
    },
  },
});

export const { setUser, setNewAvatar, setUserLanguage, clearUser } = userSlice.actions;
export default userSlice.reducer;
